export default {"src":"/_next/static/media/calendarTime_24.e658dffd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};